import { defineAsyncComponent } from 'vue';

const Header = defineAsyncComponent(() => import('./Header'));
// const Header = defineAsyncComponent(() => import('./Header.vue')));
// const Header = defineAsyncComponent(() => import('./Header'));

const Chart = defineAsyncComponent(() => import('./chart/Chart'));
const ChartActions = defineAsyncComponent(() => import('./chart/ChartActions'));
const FullScreenFileDrop = defineAsyncComponent(() => import('./FullScreenFileDrop'));

const Loader = defineAsyncComponent(() => import('./Loader'));
const Login = defineAsyncComponent(() => import('./Login'));
const NavBar = defineAsyncComponent(() => import('./NavBar'));
const Organization = defineAsyncComponent(() => import('./Organization'));
const PasswordResetRequest = defineAsyncComponent(() => import('./PasswordResetRequest'));
const ReportProgressStatus = defineAsyncComponent(() => import('./ReportProgressStatus'));
const ResetPassword = defineAsyncComponent(() => import('./ResetPassword'));
const SomethingWentWrong = defineAsyncComponent(() => import('./SomethingWentWrong'));
const VerifyEmail = defineAsyncComponent(() => import('./VerifyEmail'));

export {
  Chart,
  ChartActions,
  FullScreenFileDrop,
  Header,
  Loader,
  Login,
  NavBar,
  Organization,
  PasswordResetRequest,
  ReportProgressStatus,
  ResetPassword,
  SomethingWentWrong,
  VerifyEmail,
};

export default {};
